import selectionsTemplate from './selections.html';
import selectionDetailTemplate from './selectionDetail.html';
import selectionPurchaseTemplate from './selectionPurchase.html';
import selectionsAllPurchasableTemplate from './selectionsAllPurchasable.html';

/* @ngInject */
const SelectionsConfig = ($stateProvider) => {
    $stateProvider
        .state('selections', {
            url: '/selections',
            template: selectionsTemplate,
            controller: 'SelectionsController',
            controllerAs: 'selections',
            resolve:{
                init: function($ionicConfig){
                    $ionicConfig.scrolling.jsScrolling(false);
                }
            }
        })
        .state('selectionDetail', {
            url: '/selections/:selectionId',
            template: selectionDetailTemplate,
            controller: 'SelectionDetailController',
            controllerAs: 'selection'
        })
        .state('selectionsAllPurchasable', {
            url: '/selectionsPurchasable/all',
            params: { showHelp: null },
            template: selectionsAllPurchasableTemplate,
            controller: 'SelectionsAllPurchasableController',
            controllerAs: 'selections',
            resolve:{
                init: function($ionicConfig){
                    $ionicConfig.scrolling.jsScrolling(false);
                }
            }
        })
        .state('selectionPurchase', {
            url: '/selectionsPurchasable/:selectionId',
            template: selectionPurchaseTemplate,
            controller: 'SelectionPurchaseController',
            controllerAs: 'selectionPurchase'
        });
};

export default SelectionsConfig;


/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selections.config.js
 **/